import React, {useContext, useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputDate from "../components/Form/UiInputDate";
import UiInputMoney from "../components/Form/UiInputMoney";
import moment from "moment";
import UiInputTextEditor from "../components/Form/UiInputTextEditor";
import {get, useApiList, getExtruturaList} from "../services/ApiService";
import UiGridFormTable from "../components/Form/UiGridFormTable";
import UiParcelasTable from "../components/Form/UiParcelasTable";
import {Util} from "../util/Util";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import {Message} from "primereact/message";
import Overlay from "../components/Overlay";

import AuthProvider from "../services/AuthProvider";
import UIFotoUploadV2 from "../components/Form/UIFotoUploadV2";
import UIDocumentoUpload from "../components/Form/UIDocumentoUpload";
import "../components/Form/UIUploadShared.css";

import {UiVerticalTabs, VerticalTab} from "../components/Form/UiVerticalTabs";
import UiSelectPicker from "../components/Form/UiSelectPicker";

export default function ContratoForm(props) {

    const { user } = useContext(AuthProvider);

    const estruturaListBase = getExtruturaList();
    const estruturaList = Object.keys(estruturaListBase).map((key) => ({ id: key, title: estruturaListBase[key] }));

    let defaultValues = props.data;
    if (!defaultValues) {
        defaultValues = {
            dataFechamento: moment().format('YYYY-MM-DD'),
            dados: { estrutura: 120 },
        }
    }

    const methods = useForm({
        defaultValues: defaultValues,
        shouldUnregister: false
    });
    const { handleSubmit, watch, setValue, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    //const dados = watch('dados');

    const plataformaList = [
        { id: 1, title: 'Solarman' },
        { id: 2, title: 'Solis' },
        { id: 3, title: 'Growatt' },
        { id: 99, title: 'Outra' },
    ];

    const tipoDocumentoList = useApiList('tipoDocumentoList');
    const situacaoList = useApiList('contratoSituacaoList');
    const modeloList = useApiList('contratoModeloList');

    const allData = watch();

    const onSelectOrcamento = (data) => {
        if (data) {
            if (!allData.precoVenda || allData.precoVenda == '' || allData.precoVenda < 1) {
                setValue('precoVenda', data.kit_preco_venda);
                setValue('precoEquipamentos', data.kit_preco);
                setValue('precoEquipamentosArgon', 0);
                setValue('precoMaoObra', data.kit_preco_venda - data.kit_preco);
                setValue('geracaoGarantida', data.geracao_garantida);
            }
        }
    }

    const gerarParcelas = (numeroParcelas, baseCalculo, precoVenda, precoEquipamentos, precoEquipamentosArgon, precoMaoObra) => {
        if (!numeroParcelas || !baseCalculo) return [];

        let valorBase = 0;
        switch (baseCalculo) {
            case 'total':       valorBase = precoVenda || 0; break;
            case 'equipamentos': valorBase = (precoEquipamentos || 0) + (precoEquipamentosArgon || 0); break;
            case 'maoobra':     valorBase = precoMaoObra || 0; break;
            default:            valorBase = precoVenda || 0;
        }

        if (!valorBase) return [];

        const valorParcela = (valorBase / numeroParcelas).toFixed(2);
        const parcelas = [];
        const primeiraParcela = moment().add(1, 'month').date(15);

        for (let i = 1; i <= numeroParcelas; i++) {
            parcelas.push({
                numero: i,
                dataVencimento: primeiraParcela.clone().add(i - 1, 'month').format('YYYY-MM-DD'),
                valor: parseFloat(valorParcela)
            });
        }

        const somaCalculada = parcelas.reduce((sum, p) => sum + p.valor, 0);
        const diferenca = valorBase - somaCalculada;
        if (diferenca !== 0 && parcelas.length > 0) {
            parcelas[parcelas.length - 1].valor += diferenca;
        }

        return parcelas;
    }

    useEffect(() => {
        if (allData.precoVenda) {
            const equipamentosFornecedor = allData.precoEquipamentos || 0;
            const equipamentosArgon = allData.precoEquipamentosArgon || 0;
            const maoObra = allData.precoVenda - equipamentosFornecedor - equipamentosArgon;

            if (maoObra >= 0 && maoObra <= allData.precoVenda) {
                setValue('precoMaoObra', maoObra);
            }
        }
    }, [allData.precoEquipamentos, allData.precoEquipamentosArgon, allData.precoVenda]);

    useEffect(() => {
        const numeroParcelas = allData?.dados?.pagamento?.numeroParcelas;
        const baseCalculo = allData?.dados?.pagamento?.baseCalculo;
        const tipoPagamento = allData?.dados?.pagamento?.tipo;

        if (tipoPagamento === 'aprazo' && numeroParcelas && baseCalculo) {
            const parcelas = gerarParcelas(
                numeroParcelas, baseCalculo,
                allData?.precoVenda, allData?.precoEquipamentos,
                allData?.precoEquipamentosArgon, allData?.precoMaoObra
            );
            setValue('dados.pagamento.parcelas', parcelas);
        }
    }, [
        allData?.dados?.pagamento?.numeroParcelas,
        allData?.dados?.pagamento?.baseCalculo,
        allData?.dados?.pagamento?.tipo,
        allData?.precoVenda,
        allData?.precoEquipamentos,
        allData?.precoEquipamentosArgon,
        allData?.precoMaoObra
    ]);

    if (props.loading) {
        return <Overlay show={true} />;
    }

    return (
        <>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <WindowBody noPadding>
                        <UiVerticalTabs>
                            <VerticalTab title="Dados Gerais">
                                <div className="row">
                                    {/* COLUNA 1 */}
                                    <div className="col-4">
                                        <fieldset>
                                            <legend>Informações Básicas</legend>
                                            <div className="row">
                                                <UiInputSuggest onSelect={onSelectOrcamento} size={12} router="orcamento" idField="id" titleField="cliente.nome" name="orcamento" label="Orçamento"/>
                                                <UiInputText size={12} name="identificador" label="Apelido do Projeto"/>
                                                <UiInputDate dateFormat="dd/mm/yy" size={6} name="dataFechamento" label="Data Fechamento"/>
                                                {situacaoList && <UiInputList size={6} name="situacao" list={situacaoList} idField="id" titleField="title" label="Situacao" valueAsNumber={true} placeholder={false} />}
                                                <UiInputSuggest size={12} router="cliente" idField="id" titleField="nome" name="clienteInstalacao" label="Local de Instalação"/>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Valores</legend>
                                            <div className="row">
                                                <UiInputMoney size={6} name="precoVenda" label="Venda"/>
                                                <UiInputMoney size={6} name="precoEquipamentos" label="Equipamentos (Forn.)"/>
                                                <UiInputMoney size={6} name="precoEquipamentosArgon" label="Equipamentos (Argon)"/>
                                                <UiInputMoney size={6} name="precoMaoObra" label="Mão de Obra"/>
                                            </div>
                                        </fieldset>
                                    </div>

                                    {/* COLUNA 2 */}
                                    <div className="col-8">
                                        <fieldset>
                                            <legend>Modelo do Contrato</legend>
                                            <div className="row">
                                                {modeloList && <UiInputList size={12} name="modelo" list={modeloList} idField="id" titleField="title" label="Modelo do Contrato" valueAsNumber={true} />}
                                                {allData.modelo == 9999 && (
                                                    <UiInputTextEditor size={12} name="descPagamento" label="Texto" style={{ height: 300, overflow: 'auto' }}/>
                                                )}
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Observações</legend>
                                            <div className="row">
                                                <UiInputTextEditor size={12} name="dados.textoLivre" label="Dados Extras" style={{ height: 200, overflow: 'auto' }}/>
                                            </div>
                                        </fieldset>

                                        <fieldset style={!allData?.id ? { position: 'relative' } : undefined}>
                                            <legend>Documentos</legend>
                                            {!allData?.id && (
                                                <div className="upload-bloqueado-overlay">
                                                    <div className="upload-bloqueado-message">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                        <p>Salve o contrato primeiro para adicionar documentos</p>
                                                    </div>
                                                </div>
                                            )}
                                            <UIDocumentoUpload
                                                name="dados.documentoList"
                                                contId={allData?.id}
                                                tipoDocumentoList={tipoDocumentoList}
                                            />
                                        </fieldset>
                                    </div>
                                </div>
                            </VerticalTab>

                            <VerticalTab title="Fiscal e Financeiro">
                                <div className="row">
                                    <div className="col-4">
                                        <fieldset>
                                            <legend>Notas Fiscais</legend>
                                            <div className="row">
                                                <UiInputText size={12} name="dados.notaEquipamentosFornecedor.chave" label="NF-e Equipamentos - Fornecedor (Chave)"/>
                                                <UiInputText size={12} name="dados.notaEquipamentosArgon.chave" label="NF-e Equipamentos - Argon Solar (Chave)"/>
                                                <UiInputText size={12} name="dados.notaMaoObra.chave" label="NFS-e Mão de Obra (Chave)"/>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="col-8">
                                        <fieldset>
                                            <legend>Configuração de Pagamento</legend>
                                            <div className="row">
                                                <UiInputList size={4} name="dados.pagamento.tipo" list={[
                                                    { id: 'avista', title: 'À Vista' },
                                                    { id: 'aprazo', title: 'A Prazo' }
                                                ]} idField="id" titleField="title" label="Condição" placeholder="Selecione o tipo de pagamento" />
                                                {allData?.dados?.pagamento?.tipo === 'aprazo' && <>
                                                    <UiInputList size={4} name="dados.pagamento.baseCalculo" list={[
                                                        { id: 'total', title: 'Valor Total' },
                                                        { id: 'equipamentos', title: 'Equipamentos' },
                                                        { id: 'maoobra', title: 'Mão de Obra' }
                                                    ]} idField="id" titleField="title" label="Valor" placeholder="Selecione a base de cálculo" />
                                                    <UiInputNumberInteger size={4} min={1} max={24} name="dados.pagamento.numeroParcelas" label="Parcelas" placeholder="Ex: 12"/>
                                                </>}
                                            </div>
                                            {allData?.dados?.pagamento?.tipo === 'aprazo' && (
                                                <div className="row">
                                                    <div className="col-12">
                                                        <UiParcelasTable name="dados.pagamento.parcelas" />
                                                    </div>
                                                </div>
                                            )}
                                        </fieldset>
                                    </div>
                                </div>



                            </VerticalTab>

                            <VerticalTab title="Técnico">
                                <div className="row">
                                    <div className="col-4">
                                        <fieldset>
                                            <legend>Dados do Local de Instalação</legend>
                                            <div className="row">
                                                <UiInputList size={12} name="dados.estrutura" list={estruturaList} idField="id" titleField="title" label="Estrutura" valueAsNumber={true} />
                                                <UiInputText size={12} name="dados.disjuntor" label="Potencia do Disjuntor"/>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="col-8">
                                        <fieldset>
                                            <legend>Dados da Plataforma</legend>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-item">
                                                        <label className="form-label">
                                                            Usuário (Login)
                                                            <a className="link-element" href="#" onClick={(e) => {
                                                                e.preventDefault();
                                                                const clienteNome = allData?.orcamento?.cliente?.nome || allData?.cliente?.nome || '';
                                                                if (!clienteNome) {
                                                                    alert('Selecione um cliente primeiro');
                                                                    return;
                                                                }
                                                                const primeiroNome = clienteNome.split(' ')[0].toLowerCase();
                                                                const usuario = `argon-${primeiroNome}`;
                                                                const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                                                                const alfanumericos = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                                                                const letraMaiuscula = letras[Math.floor(Math.random() * letras.length)];
                                                                let meio = '';
                                                                for (let i = 0; i < 10; i++) {
                                                                    meio += alfanumericos[Math.floor(Math.random() * alfanumericos.length)];
                                                                }
                                                                const senha = letraMaiuscula + meio;
                                                                setValue('dados.usuario', usuario);
                                                                setValue('dados.senha', senha);
                                                            }}>
                                                                Gerar
                                                            </a>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            {...methods.register('dados.usuario')}
                                                        />
                                                    </div>
                                                </div>
                                                <UiInputText size={4} name="dados.senha" label="Senha"/>
                                                <UiInputList size={4} name="dados.plataforma" list={plataformaList} idField="id" titleField="title" label="Plataforma" />
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <fieldset style={!allData?.id ? { position: 'relative' } : undefined}>
                                    <legend>Fotos</legend>
                                    {!allData?.id && (
                                        <div className="upload-bloqueado-overlay">
                                            <div className="upload-bloqueado-message">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                <p>Salve o contrato primeiro para adicionar fotos</p>
                                            </div>
                                        </div>
                                    )}
                                    <UIFotoUploadV2
                                        name="dados.fotos"
                                        contId={allData?.id}
                                    />
                                </fieldset>
                            </VerticalTab>
                        </UiVerticalTabs>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    );
}
